import { ServiceBase } from '../../../../core/services/ServiceBase'
import Proxy from './proxy'

const slidingExpireTimeInMinute = 60 * 24 // 1 day

class Service extends ServiceBase {
  getSearchPortfolio(params) {
    return this.getData(() => Proxy.getSearchPortfolio(params))
  }
  getTotalCompanyBySettings(params) {
    return this.getData(() => Proxy.getTotalCompanyBySettings(params))
  }
  getFilteredScoreRange(params) {
    return this.getData(() => Proxy.getFilteredScoreRange(params))
  }
  getProvinceVietNam(params) {
    return this.applyMemoryCache(
      'CategoryService.getVietnameseLocation', // Same key in CategoryService
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => Proxy.getProvinceVietNam(params))
  }
  getVSIC(params) {
    return this.applyMemoryCache(
      'CategoryService.getVsic', // Same key in CategoryService
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => Proxy.getVSIC(params))
  }
  getFilteredCompaniesBusinessSize(params) {
    return this.getData(() => Proxy.getFilteredCompaniesBusinessSize(params))
  }
  getFilteredCompaniesBusinessAge(params) {
    return this.getData(() => Proxy.getFilteredCompaniesBusinessAge(params))
  }
  getSearchExcludeCompanyInPortfolio(params) {
    return this.getData(() => Proxy.getSearchExcludeCompanyInPortfolio(params))
  }
  postSaveFilter(params) {
    return this.getData(() => Proxy.postSaveFilter(params))
  }
  getFilterDefault(params) {
    return this.getData(() => Proxy.getFilterDefault(params))
  }
  getCompanies(params) {
    return this.getData(() => Proxy.getCompanies(params))
  }
}

export default new Service()
